/**
 * SuperAdminRoute — only the platform account owner may access (API keys, etc.).
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated, clearAuthAndRedirectToLogin, isSuperAdmin } from "../utils/auth";

const SuperAdminRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      clearAuthAndRedirectToLogin();
      return;
    }
    if (!isSuperAdmin()) {
      navigate("/403");
    }
  }, [navigate]);

  if (!isAuthenticated() || !isSuperAdmin()) return null;

  return children;
};

export default SuperAdminRoute;
